import { ReactComponent as TrashIconSVG } from '@/assets/icons/TrashIcon.svg';
import { SVGProps } from 'react';

const TrashIcon = (props: SVGProps<SVGSVGElement>) => <TrashIconSVG {...props} />;

export default TrashIcon;
